import Healthkit from './index.native'

export * from './index.native'

export default Healthkit
